import React, {useMemo, useState} from "react";
import {IconButton} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import {useFiltered} from "@atttomyx/shared-hooks";
import {Cards, FiltersAccordion, FloatingAddButton} from "@atttomyx/react-components";
import {NodeCard} from "../cards";
import {AddConnectionDialog, EditNodeDialog} from "../dialogs";
import {NodeFilters} from "../filters";
import {nodeService} from "../../services";
import {users, users as userUtils} from "@atttomyx/shared-utils";
import {confirm} from "@atttomyx/react-utils";
import {nodeUtils} from "../../utils";
import {ADD_NEW} from "../../constants";
import "./cardsView.css";

const CardsView = (props) => {
    const { dimensions, snackbar, user, nodes, filters, horizontal, categories, people, rootId,
        onSaveNode, onSaveEdge, onDeleteNode, onDeleteEdge } = props;
    const [ showFilters, setShowFilters ] = useState(false);
    const [ showAdd, setShowAdd ] = useState(false);
    const [ showEdit, setShowEdit ] = useState(false);
    const [ node, setNode ] = useState(null);
    const [ deleting, setDeleting ] = useState(null);
    const filtered = useFiltered(nodes, filters, userUtils.sortByName);

    const edge = useMemo(() => {
        return {
            sourceNodeId: rootId,
            targetNodeId: ADD_NEW,
        }
    }, [rootId]);

    const deleteNode = (nodeId) => {
        setDeleting(nodeId);

        const success = (deletedId) => {
            setDeleting(null);
            onDeleteNode(deletedId);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setDeleting(null);
        };

        nodeService.deleteNode(nodeId, success, failure);
    };

    return <div className="cards-view">
        <div className="filters">
            <FiltersAccordion
                filters={filters}
                form={NodeFilters}
                open={showFilters}
                onOpen={() => setShowFilters(true)}
                onClose={() => setShowFilters(false)}
            />
        </div>
        <Cards
            items={filtered}
            paging={filters.paging}
            dimensions={dimensions}
            renderer={(node) => node.id === deleting ? null :
                <NodeCard key={node.id} node={node} user={user}>
                    <IconButton
                        color="secondary"
                        title="Delete"
                        className="delete"
                        disabled={nodeUtils.isRoot(node, user)}
                        onClick={() => confirm.confirmDelete(users.getFullName(node), () => deleteNode(node.id))}
                    >
                        <DeleteIcon/>
                    </IconButton>
                    <IconButton
                        color="primary"
                        title="Edit"
                        onClick={() => {
                            setNode(node);
                            setShowEdit(true);
                        }}
                    >
                        <EditIcon/>
                    </IconButton>
                </NodeCard>}
        />
        <FloatingAddButton
            title="Add connection"
            position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
            center={false}
            onClick={() => setShowAdd(true)}
        />
        {showAdd ?
            <AddConnectionDialog
                snackbar={snackbar}
                horizontal={horizontal}
                categories={categories}
                people={people}
                edge={edge}
                onCancel={() => setShowAdd(false)}
                onSaveNode={onSaveNode}
                onSaveEdge={(saved) => {
                    setShowAdd(false);
                    onSaveEdge(saved);
                }}
                showActions={false}
            /> : null}
        {showEdit && node ?
            <EditNodeDialog
                snackbar={snackbar}
                user={user}
                node={node}
                onCancel={() => setShowEdit(false)}
                onSaveNode={(saved) => {
                    setShowEdit(false);
                    onSaveNode(saved);
                }}
                onDeleteNode={(deletedId) => {
                    setShowEdit(false);
                    onDeleteNode(deletedId);
                }}
            /> : null}
    </div>
}

export default CardsView;
